module.exports = __webpack_public_path__ + "img/passo_1.2ea2ccf1.png";